import { styled } from '@mui/material/styles';
import Link from '@mui/material/Link';

export const FooterLink = styled(Link)(({ theme }) => ({
  color: 'inherit',
  textDecoration: 'none',
  borderBottom: '1px solid transparent',
  transition: 'color 0.2s, border-bottom 0.2s',
  '&:hover': {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
})); 